import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Form, Row, Col, Input, Button, Divider } from 'antd';
import { Table } from 'src/components';
import { useQuery, roundFloat, onlyNumber } from 'src/core/utils/formater';
import newAlert from 'src/components/newAlert';
import { guilgeeColumns, customSummary } from './dataStructure/data';
import { searchList } from './dataStructure/search';
import { start_loading, end_loading } from '../../../core/actions/loader';

const GuilgeeBalanceTailan = () => {
  const dispatch = useDispatch();
  const query = useQuery();
  const socket = useSelector((state) => state.socket);
  const data_date = useSelector((state) => state.data_date);

  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState({
    json_array: [],
    sum_data: {},
    total: 0,
  });

  const [form] = Form.useForm();

  const generateTailan = useCallback(
    (month) => {
      socket.on('request_out', (data) => {
        socket.removeAllListeners('request_out');

        if (data.status === '0') {
          console.log(data.content);

          setTableData(data.content);
        } else {
          newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
        }

        dispatch(end_loading({}));
      });

      const page = query.get('page');
      const size = query.get('size') || 50;
      const search = {
        dans_dugaar: query.get('dans_dugaar'),
      };

      socket.emit('request_in', {
        channel: 'ts001_02_tailan_control',
        content: {
          action_type: 'get_gb_sanhuu',
          month_start: '1',
          month_end: String(month),
          paging: { page, size, search },
        },
      });

      dispatch(start_loading({}));
    },
    [socket, query, dispatch]
  );

  const saveValues = (saveData) => {
    socket.on('request_out', (data) => {
      socket.removeAllListeners('request_out');

      if (data.status === '0') {
        newAlert({ type: 'success', msg: 'Амжилттай хадгалагдлаа' });
        generateTailan(data_date.month);
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
      }

      dispatch(end_loading({}));
    });

    socket.emit('request_in', {
      channel: 'ts001_02_dans_control',
      content: {
        action_type: 'set_dans_dun',
        month: 0,
        data: saveData,
      },
    });

    dispatch(start_loading({}));
  };

  useEffect(() => {
    if (data_date?.month) {
      generateTailan(data_date.month);
    }
  }, [data_date, query, generateTailan]);

  const edit = (row) => {
    form.setFieldsValue({
      dans_id: row?.dans_id,
      valiut_torol: row?.valiut_torol,
      dans_dun_deb: roundFloat(row?.dun_eh_deb),
      dans_dun_cred: roundFloat(row?.dun_eh_cred),
      dans_dun_valiut_deb: 0,
      dans_dun_valiut_cred: 0,
    });

    setVisible(true);
  };

  const title = () => (
    <div className="table-title-text-center">Гүйлгээний тэнцэл</div>
  );

  return (
    <>
      <div className="table-antd-div no-scroll">
        <Table
          columns={guilgeeColumns({ customEdit: edit })}
          dataSource={tableData?.json_array}
          scroll={{
            y: 'calc(100vh - 330px)',
          }}
          summaryList={{
            sumColumn: customSummary,
            sumDataSource: tableData?.sum_data,
          }}
          title={title}
          total={tableData?.total}
          isSearch
          searchList={searchList}
        />
      </div>
      <Modal
        className="custom-modal"
        title="Гүйлгээний тэнцлийн дүн засах"
        open={visible}
        closable={false}
        maskClosable={false}
        width={400}
        footer={null}
      >
        <CustomModal
          onClose={() => setVisible(false)}
          form={form}
          saveValues={saveValues}
        />
      </Modal>
    </>
  );
};

const layout = {
  labelCol: { xs: { span: 9 }, sm: { span: 9 } },
  wrapperCol: { xs: { span: 15 }, sm: { span: 15 } },
};

const CustomModal = ({ onClose = () => {}, form = null, saveValues }) => {
  const onFinish = (values) => {
    saveValues(values);
    onClose();
  };

  const onCancel = () => {
    onClose();
  };

  const isHide = form.getFieldValue('valiut_torol') === 'MNT';

  return (
    <div className="dans-medeelel-container">
      <Form
        form={form}
        onFinish={onFinish}
        className="register-form"
        {...layout}
        size="small"
      >
        <Form.Item name="dans_id" hidden />
        <Form.Item name="valiut_torol" hidden />
        <Form.Item
          name="dans_dun_deb"
          label="Дебет /төгрөг/"
          labelAlign="left"
          rules={[{ required: true, message: '' }]}
          normalize={onlyNumber}
        >
          <Input className="w-100 text-align-r" />
        </Form.Item>
        <Form.Item
          name="dans_dun_cred"
          label="Кредит /төгрөг/"
          labelAlign="left"
          rules={[{ required: true, message: '' }]}
          normalize={onlyNumber}
        >
          <Input className="w-100 text-align-r" />
        </Form.Item>

        <Row>
          <Col span={24} className="text-align-r">
            <Form.Item noStyle>
              <Button
                onClick={onCancel}
                className="cancel-btn"
                type="primary"
                shape="round"
              >
                Цуцлах
              </Button>
              <Button
                className="confirm-btn ml-5"
                type="primary"
                shape="round"
                htmlType="submit"
              >
                Хадгалах
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default GuilgeeBalanceTailan;
